<template>
  <div class="cart-confirm" style="display:block" v-if="showConfirm">
    <div class="confirm-content">
      <div class="header-img">
        <img src="@assets/images/cart_confirm_icon.png" alt />
      </div>
      <div class="title-tip">
        {{TLang('您的','list')}}
        <span class="prominent">{{TLang('东福礼品卡','list')}}</span>
        {{TLang('限购买礼包商品','list')}}
        <br />{{TLang('如需与优选商品一起结算','list')}}
      </div>
      <div class="product-list">
        <div class="title">{{TLang('礼包商品如下','list')}}</div>
        <div class="product-row" v-for="(item, index) in products" :key="index">
          <div class="product-row-img">
            <img :src="item.masterImgUrl" alt />
          </div>
          <div class="product-row-title">
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="footer-buttons">
        <div class="next">
          <img src="@assets/images/next.png" alt @click="callback('next')" />
        </div>
        <div class="cancel">
          <img src="@assets/images/cancel.png" alt @click="callback('cancel')" />
        </div>
      </div>
    </div>
    <div class="confirm-modal"></div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      default: () => []
    },
    showConfirm: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    callback(type) {
      this.$emit("callback", type);
    }
  }
};
</script>

<style lang="less">
.confirm-modal {
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  height: 100vh;
  width: 100vw;
  z-index: 10000;
}
.confirm-content {
  position: fixed;
  padding: 36px 32px 11px 36px;
  width: 492px;
  height: 433px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background-color: #fff;
  opacity: 1;
  z-index: 10001;
  top: calc(50vh - 280px);
  left: calc(50vw - 240px);
  .header-img {
    margin-left: auto;
    margin-right: auto;
    width: 64px;
    height: 56px;
    img {
      width: 64px;
      height: 56px;
    }
  }
  .title-tip {
    margin: auto;
    margin-top: 11px;
    text-align: center;
    width: 380px;
    height: 54px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 19px;
    .prominent {
      color: #333333;
      font-weight: 600;
    }
  }
  .product-list {
    margin-top: 25px;
    width: calc(100% - 15px);
    max-height: calc(100% - 190px);
    overflow-y: auto;
    .title {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(178, 178, 178, 1);
      line-height: 16px;
    }
    .product-row:first-child {
      margin-top: 4px;
    }
    .product-row {
      margin-bottom: 22px;
      height: 68px;
      background: rgba(255, 255, 255, 1);
      padding: 6px;
      display: flex;
      &-img {
        width: 68px;
        height: 68px;
        line-height: 68px;
        img {
          max-width: 68px;
          max-height: 68px;
          width: 68px;
          height: 68px;
          justify-content: center;
          vertical-align: middle;
        }
      }
      &-title {
        margin-left: 22px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(17, 17, 17, 1);
        line-height: 18px;
        display: flex;
        /*实现垂直居中*/
        align-items: center;
        /*实现水平居中*/
        justify-content: center;
        text-align: justify;
        span {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }
  .footer-buttons {
    position: absolute;
    bottom: 0px;
    width: calc(100% - 68px);
    height: 56px;
    background: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 4px 4px;
    cursor: pointer;
    display: flex;
    & > div {
      text-align: center;
      flex: 1;
      line-height: 56px;
      img {
        vertical-align: middle;
      }
    }
    & > div:first-child {
      text-align: right;
      padding-right: 16px;
    }
    & > div:last-child {
      text-align: left;
      padding-left: 16px;
    }
  }
}
</style>
